import { AutoCompleteTriggerService } from './../../../../services/shared/auto-complete-trigger/auto-complete-trigger.service';
import { OfferStatus } from './../../../../shared/enums/offer-status/offer-status.module';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Block } from '../../../../models/block.model';
import { CustomerPageData } from '../../../../models/customerPageData.model';
import { TranslationService } from '../../../../services/translation/translation.service';
import { Customer } from '../../../../models/customer.model';
import { UtilsService } from '../../../../services/shared/utils/utils.service';
import { RoleType } from '../../../../shared/enums/role-type/role-type.module';
import { CustomerPage } from '../../../../models/customerPage.model';
import { TooltipPosition } from '../../../../models/tooltipPosition.model';
import { GroupFormComponent } from './group-form/group-form.component';
import { RefBusinessLists } from '../../../../models/refBusinessLists.model';
import { ConnectionDefinition } from '../../../../models/connectionDefinition.model';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { AppStateService } from '../../../../services/shared/app-state/app-state.service';


@Component({
  selector: 'app-block-form',
  templateUrl: './block-form.component.html',
  styleUrl: './block-form.component.css'
})
export class BlockFormComponent implements OnInit {
  @Input() customerPage!: CustomerPage;
  @Input() block!: Block;
  @Input() customer!: Customer;
  @Input() customersData!: CustomerPageData[];
  @Input() userRole!: RoleType;
  @Input() currentBlockId: string | undefined | null;
  @Input() currentBlockIteration: number | undefined;
  @Input() isSummary!: boolean;
  @Input() offerStatus!: OfferStatus;
  @Input() refBusinessLists!: RefBusinessLists;
  @Input() fullConnectionsDefinitions!: ConnectionDefinition[];
  @Input() isCurrentBlock!: boolean;
  @Output() customersDataChange = new EventEmitter<CustomerPageData[]>();
  @Output() fieldContainerClick = new EventEmitter<HTMLElement>();
  @Output() openHelpDialog = new EventEmitter<void>();
  @Output() checkErrors = new EventEmitter<void>();

  isEditable: boolean = false;
  isPreview: boolean = false;
  isEmbed: boolean = false;
  constructor(
    public translationService: TranslationService,
    private elRef: ElementRef,
    private utils: UtilsService,
    private autoCompleteTriggerService: AutoCompleteTriggerService,
    private appState: AppStateService) { }

  @ViewChild('slideContent') slideContent!: ElementRef;

  ngOnInit(): void {
    this.isPreview = this.appState.getIsPreview();
    this.isEmbed = this.appState.getIsEmbed();
  }

  ngAfterViewInit() {
    const slideContent = this.elRef.nativeElement.querySelector('.slideContent');
    if(!slideContent.closest('.cdc-summary'))
    slideContent.addEventListener('wheel', (event: WheelEvent) => {
      this.utils.preventScrollOutside(event, slideContent);
      this.autoCompleteTriggerService.closeAll();
    });
    this.isEditable = this.groupForms.some(x => x.isEditable);
  }

  scrollToFirstTooltipError()
  {
    const shownTooltips = this.tooltipData.filter(t => t.show === true);
    var firstTooltipError = shownTooltips.reduce((lowest, tooltip) => {
      if (tooltip.top !== undefined && (lowest.top === undefined || tooltip.top < lowest.top)) {
        return tooltip;
      }
      return lowest;
    });

    if(firstTooltipError && this.slideContent)
    {
      const fieldElement = document.querySelector(`.field-${firstTooltipError.index}`) as HTMLElement;
      const slideContentEl = this.slideContent.nativeElement;

      const fieldPosition = fieldElement.getBoundingClientRect().top - slideContentEl.getBoundingClientRect().top;

      slideContentEl.scrollTo({
        top: fieldPosition,
        behavior: 'smooth'
      });
    }
  }

  scrollToSchedule(scheduleElement: HTMLElement) {
    if(this.utils.isDesktop())
    {
      if(this.slideContent)
      {
        const slideContentEl = this.slideContent.nativeElement;
        const schedulePosition = scheduleElement.offsetTop - slideContentEl.offsetTop;
        slideContentEl.scrollTo({
          top: schedulePosition,
          behavior: 'smooth'
        });
      }
    }
    else{
      const mainContentElement = document.querySelector('.mainContent') as HTMLElement;
      if(mainContentElement)
      {
        const schedulePosition = scheduleElement.offsetTop - mainContentElement.offsetTop;

        mainContentElement.scrollTo({
          top: schedulePosition,
          behavior: 'smooth'
        });
      }
    }
  }
  onGroupFormClick(element: HTMLElement) {
    this.fieldContainerClick.emit(element);
  }

  handleCustomerPageDatasChange(updatedCustomersData: CustomerPageData[]) {
    this.customersData = updatedCustomersData;
    this.customersDataChange.emit(updatedCustomersData);
  }

  onOpenHelpDialog()
  {
    if(!this.isSummary && !this.isEmbed){
      this.openHelpDialog.emit();
    }
  }

  @ViewChild('blockTitle') blockTitle!: ElementRef;
  tooltipData: Array<TooltipPosition> = [];

  // Emitir a atualização durante o scroll
  onScroll() {
    //update all
    this.updateTooltipsPosition();
  }

  onTooltipPositionChanged(groupTooltipPositions: Array<TooltipPosition>) {
    groupTooltipPositions.forEach(position => {
      var tooltip = this.tooltipData.find(x => x.index == position.index);
      if(tooltip){
        tooltip.show = position.show;
      }
      else{
        this.tooltipData.push(position);
      }

      const slideContentRect = this.slideContent.nativeElement.getBoundingClientRect();
      this.updateTooltipPosition(position, slideContentRect);
    });

    this.deleteUnusedErrorTooltips();
  }

  updateTooltipsPosition() {
    if(this.slideContent || !this.utils.isDesktop())
    {
      const slideContentRect = this.slideContent.nativeElement.getBoundingClientRect();
      this.tooltipData.forEach((tooltip) => {
        this.updateTooltipPosition(tooltip, slideContentRect);
      });
    }
  }

  updateTooltipPosition(tooltip:TooltipPosition, slideContentRect: DOMRect) {
    const tooltipElement = document.querySelector(`.tooltip-${tooltip.index}`) as HTMLElement;
    const fieldElement = document.querySelector(`.field-${tooltip.index}`) as HTMLElement;
    const zoom = this.utils.getRootZoom();
    if(fieldElement && tooltipElement)
    {
      var fieldMeasures = fieldElement.getBoundingClientRect();

      if(tooltip.show)
      {
        if(this.utils.isDesktop())
        {
          const blockTitleHeight = this.blockTitle.nativeElement.getBoundingClientRect().height;
          tooltipElement.style.display = 'block';
          tooltipElement.style.visibility = 'hidden';
          var parent = tooltipElement.offsetParent as HTMLElement | null;
          const parentRect = parent?.getBoundingClientRect() ?? slideContentRect;
          var tooltipArrowStyle = getComputedStyle(tooltipElement, '::after');
          var tooltipArrowHeight = parseFloat(tooltipArrowStyle.borderWidth);
          tooltipElement.style.display = 'none';
          tooltipElement.style.visibility = 'unset';

          //top
          var totalHeight = this.utils.getTotalHeight(fieldElement) * zoom;
          var top = (fieldMeasures.top + totalHeight + tooltipArrowHeight - parentRect.top) / zoom;
          tooltipElement.style.top = `${top}px`;
          tooltip.top = top;

          //left
          const cdcFormField = fieldElement.closest('.cdc-form-field') as HTMLElement ?? fieldElement.querySelector('.cdc-form-field') ?? fieldElement;
          var left = cdcFormField.getBoundingClientRect().left - parentRect.left;
          tooltipElement.style.left = `${left/ zoom}px`;

          const outOfBounds = top < blockTitleHeight || top > (parentRect.height / zoom);
          tooltipElement.style.display = outOfBounds ? 'none' : 'block';
        }
        else
        {
          var parentElement = fieldElement.parentElement ? fieldElement.parentElement : fieldElement;
          //top
          var top = parentElement.offsetTop + fieldElement.offsetHeight + 5; //5 from arrow
          tooltipElement.style.top = `${top}px`;
          tooltip.top = top;

          //left
          var left = parentElement.offsetLeft;
          tooltipElement.style.left = `${left/ zoom}px`;

          tooltipElement.style.display = 'block';
        }
      }
      else{
        tooltipElement.style.display = 'none';
      }
    }
  }

  @ViewChildren(GroupFormComponent) groupForms!: QueryList<GroupFormComponent>;
  //Send request for all fields to do evaluate, from page
  runEvaluateAllComponents(displayErrors: boolean): boolean
  {
    var blockHasErrors = false;
    this.groupForms.forEach(groupForm => {
      var groupHasErrors = groupForm.runEvaluateAllComponents(displayErrors);

      if (!blockHasErrors && groupHasErrors) {
        blockHasErrors = groupHasErrors;
      }
    });

    return blockHasErrors;
  }

  closeAllTooltipErrorsOnCurrentBlock(tooltipIndexExcluded?: string)
  {
    if(this.currentBlockId == this.block.id && this.currentBlockIteration == this.block.iteration)
    {
      this.tooltipData.filter(t => !tooltipIndexExcluded || t.index != tooltipIndexExcluded).forEach((tooltip) => {
        const tooltipElement = document.querySelector(`.tooltip-${tooltip.index}`) as HTMLElement;
        if (tooltipElement) {
          tooltipElement.style.display = 'none';
        }
      });
      this.tooltipData = tooltipIndexExcluded ? this.tooltipData.filter(t => t.index == tooltipIndexExcluded) : [];
    }
  }

  deleteUnusedErrorTooltips()
  {
    if(this.currentBlockId == this.block.id && this.currentBlockIteration == this.block.iteration)
    {
      this.tooltipData.forEach((tooltip) => {
        const tooltipElement = document.querySelector(`.tooltip-${tooltip.index}`) as HTMLElement;
        if(!tooltipElement)
        {
          this.tooltipData = this.tooltipData.filter(t => t.index != tooltip.index);
        }
      });
    }

    this.checkErrors.emit();
  }
}
